import React from "react";

/**
 * Global Error Boundary.
 * Prevents blank/black screens when any React component throws.
 * Shows a friendly Arabic message with reload option and error details.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
    this.setState({ info });
  }

  handleReload = () => {
    try { window.location.reload(); } catch { /* noop */ }
  };

  handleHome = () => {
    try { window.location.href = "/"; } catch { /* noop */ }
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const msg = this.state.error?.message || String(this.state.error || "خطأ غير متوقع");
    return (
      <div dir="rtl" className="min-h-[100vh] flex items-center justify-center p-6 bg-background text-foreground" data-testid="error-boundary">
        <div className="max-w-md w-full text-center space-y-4">
          <div className="text-5xl">⚠️</div>
          <h1 className="text-2xl font-black">حدث خطأ غير متوقع</h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            نعتذر، حصل خطأ أثناء عرض هذه الشاشة. لن نفقد بياناتك — يمكنك إعادة تحميل الصفحة أو العودة للرئيسية.
          </p>
          <details className="text-xs bg-muted/50 rounded-lg p-3 text-left" dir="ltr">
            <summary className="cursor-pointer font-bold">تفاصيل تقنية</summary>
            <pre className="mt-2 whitespace-pre-wrap break-words">{msg}</pre>
          </details>
          <div className="flex gap-2 justify-center pt-2">
            <button
              onClick={this.handleReload}
              className="px-5 py-2.5 rounded-xl bg-primary text-primary-foreground font-bold shadow hover:opacity-90"
              data-testid="error-boundary-reload"
            >
              إعادة تحميل
            </button>
            <button
              onClick={this.handleHome}
              className="px-5 py-2.5 rounded-xl border-2 border-primary text-primary font-bold hover:bg-primary/10"
              data-testid="error-boundary-home"
            >
              الرئيسية
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
